export default __webpack_public_path__ + "static/media/JD.a0e75607.svg";